<template>
  <div>
    <h6 class="h6 text-semibold m-0 m-b-1" selenium="appointment-type-title">
      What kind of appointment is this?
    </h6>
    <div
        v-for="{ value: purpose, long } in $options.PURPOSES_MAP"
        :key="purpose"
        class="radio RADIO">
      <input
          type="radio"
          :id="purpose"
          name="reason"
          :value="purpose"
          :selenium="`appointment-type-${purpose}`"
          :checked="value.purpose === purpose"
          @change="onChange({
            purpose,
            otherPurpose: value.otherPurpose
          })"
      />
      <label :for="purpose" :selenium="`appointment-type-label-${purpose}`">{{ long }}</label>
    </div>
    <div class="input-container m-t-0 m-b-4:t" static>
      <input
          type="text"
          placeholder="Create appointment name (optional)"
          class="input ellipsize"
          maxlength="500"
          :value="value.otherPurpose"
          selenium="appointment-type-text"
          :disabled="value.purpose !== $options.PURPOSES.other"
          @input="({ target }) => onChange({
            purpose: value.purpose,
            otherPurpose: target.value || ''
          })"
      />
    </div>
  </div>
</template>

<script>
import { PURPOSES, PURPOSES_MAP } from '@/constants/appointments';

export default {
  PURPOSES,
  PURPOSES_MAP,
  name: 'purpose-input',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        purpose: PURPOSES_MAP[PURPOSES.call].value,
        otherPurpose: '',
      }),
    },
  },
  methods: {
    onChange ({ purpose, otherPurpose }) {
      this.$emit('change', {
        ...this.value,
        purpose,
        otherPurpose: purpose !== PURPOSES.other ? '' : otherPurpose,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .RADIO {
    display: flex;
    padding-bottom: $unit;
  }
</style>
